module.exports = __webpack_public_path__ + "img/device_c9_one.2cc49463.png";